import React, { useState } from 'react';
//import { useDispatch, useSelector } from 'react-redux'; // Import der Redux-Hooks
import BlockAddress from "./BlockAddress";
import BlockPickup from "./BlockPickup";
import {setSelectedShipOrDeliverData } from '../../../../../redux/checkoutredux/actions/checkoutactions/checkoutActions'; // Import der Versand-Aktion

const BlockShipping = ({store}) => {
 // Zustand für den aktiven Tab
 //const [activeTab, setActiveTab] = useState('delivery');

 

 console.log("Store in BlockShipping: ",store.getState());
 //console.log("Shipping Method in BlockShipping: ", store.getState().shipping.shippingMethod);
 console.log("Shipping Method in BlockShipping: ", store.getState().selectedorderdata.shipordeliverdata);


 // Direkter Zugriff auf den Versandmethoden-Zustand aus dem Redux-Store
 //const shippingMethod = store.getState().shipping.shippingMethod;
 const shippingMethod = store.getState().selectedorderdata.shipordeliverdata


 //const pickupallLocations = store.getState().pickuplocations;
 const pickupallLocations = store.getState().checkoutcontext.checkoutcontextall.checkoutcontextinitial?.pickuplocations || {};


 //const shippingmethods = store.getState().deliverymethods;
 const shippingmethods = store.getState().shoppingcart.metacartdata[0].shippingmethods;

 //console.log("PICKUPLOCATIONS 1: ",pickupallLocations);

 const tmppickuplocations = ['location 1','location 2', 'location 3'];



 


 const [activeTab, setActiveTab] = useState(shippingMethod);
 
 // Direkter Zugriff auf den dispatch aus dem Redux-Store
 //const dispatch = store.dispatch;

 // Funktion zum Ändern des aktiven Tabs und des Inhalts und Aktualisieren der Versandmethode im Redux-Store
 const handleTabChange = (tab) => {
   setActiveTab(tab);
  // dispatch(setShippingMethod(tab)); // Auslösen der Versand-Aktion mit dem ausgewählten Tab
   if (tab === 'pickup') {
   // store.dispatch(setPickupCurrent("LAGER")); // Zurücksetzen der Pickup-Location, wenn der Pickup-Tab ausgewählt ist
   // store.dispatch(setShippingMethod(tab));
    store.dispatch(setSelectedShipOrDeliverData(tab));
    
  } else {
  //  store.dispatch(setPickupCurrent(null));
 //   store.dispatch(setShippingMethod(tab)); // Auslösen der Versand-Aktion mit dem ausgewählten Tab
    store.dispatch(setSelectedShipOrDeliverData(tab));
  }

  console.log("SHIPPING: ",shippingMethod);
  
 };

 return (
   <div id="ips-pickup-details" className="ips-module">
     <div className="row g-3">
       <h4 className="mb-3">Versandmethode</h4>
       <div className="my-3">
         {/* Tab-Header */}
         <div className="d-flex">
           {/* Liefern-Tab */}
           <div
             className={`flex-grow-1 checkout-shippingmetod btn ips-btn-secondary-checkout ${shippingMethod === 'delivery' ? 'active' : 'inactive'}`}
             onMouseDown={() => handleTabChange('delivery')}
           >
             Liefern
           </div>
           {/* Abholen-Tab */}
           <div
             className={`flex-grow-1 checkout-shippingmetod btn ips-btn-secondary-checkout ips-checkout-header-tab-color ${shippingMethod === 'pickup' ? 'active' : 'inactive'}`}
             onMouseDown={() => handleTabChange('pickup')}
           >
             Abholen
           </div>
         </div>
         {/* Tab-Inhalte */}
         <div className="border">
           {shippingMethod === 'delivery' && (
             <div>
               <div className="ips-checkout-blockdelivery-modul"><BlockAddress store={store}/></div>
             </div>
           )}
           {shippingMethod === 'pickup' && (
             <div>
               <div className="my-4 p-3"><BlockPickup store={store} pickuplocations={pickupallLocations} shippingmethods={shippingmethods}/></div>
             </div>
           )}
         </div>
       </div>
     </div>
   </div>
 );
};

export default BlockShipping;